import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

import { prettifyNumber } from 'utils/prettify';


@Pipe({name: 'prettifyNumber'})
export class PrettifyNumberPipe implements PipeTransform {
  transform(value: any, separator: string = ','): any {
    if (_.isNaN(value) || _.isNull(value) || !_.isNumber(value)) { return value; }
    return prettifyNumber(+value, separator);
  }
}
